import type { ReactNode } from 'react'

const CurrencyCodes = {
    USD: 'USD',
} as const

type CurrencyCode = (typeof CurrencyCodes)[keyof typeof CurrencyCodes]

export interface Currency {
    code: CurrencyCode
    decimals: number
    symbol: ReactNode
}

export const Currencies: Record<CurrencyCode, Currency> = {
    USD: {
        code: 'USD',
        decimals: 2,
        symbol: '$',
    },
}

export const DEFAULT_CURRENCY = Currencies.USD
